import React from "react"
import {
  ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
} from "recharts"
import { CHART_COLORS, formatINR } from "../constants"

export default function CollectionTrendChart({ trend = [] }) {
  if (!trend.length) return null

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">
        Collections vs Target (monthly)
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <ComposedChart data={trend}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" />
          <XAxis dataKey="month" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => formatINR(v)} />
          <Tooltip formatter={(v) => formatINR(v)} />
          <Legend />
          <Bar dataKey="collected" name="Collected" fill={CHART_COLORS.collected} radius={[4, 4, 0, 0]} />
          <Line
            dataKey="target"
            name="Target"
            stroke={CHART_COLORS.target}
            strokeWidth={2}
            strokeDasharray="5 5"
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}
